export const CappingConstants = {
    displayPath: "events/display",
    registerPath: "events/register"
};
